<div class="toolbar-container">  
  <div class="left-items">
    @for (item of items | toolbarFilter: 'left'; track item) {
      @if (!(['xs', 'sm', 'md', 'lg'] | breakpoint | async)) {
        <ng-container
          [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="{ $implicit: item }">
        </ng-container>
      }
    }
  </div>
  <div class="right-items">
    @if ((['xs', 'sm', 'md', 'lg'] | breakpoint | async) && items.length) {
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @for (item of items | toolbarButtonFilter; track item) {
          @if (!item.items.length) {
            <button mat-menu-item (click)="onClickButton(item.id)">
              <mat-icon>{{ item.icon }}</mat-icon>
              <span>{{ item.tooltip }} </span>
            </button>
          } @else {
            @for (subItem of item.items; track subItem) {
              <button mat-menu-item (click)="onClickButton(subItem.id)">
                <mat-icon>{{ subItem.icon }}</mat-icon>
                <span>{{ subItem.tooltip }} </span>
              </button>
            }
          }
        }
      </mat-menu>
    } @else {
      @for (item of items | toolbarFilter: 'right'; track item) {
        <ng-container
          [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="{ $implicit: item }">
        </ng-container>
        }
      }
  </div> 
</div>

<ng-template #itemTemplate let-item>
  @switch (item.type) {
    @case ('button') {
      <button
        mat-icon-button
        matTooltip="{{ item.tooltip }}"
        (click)="onClickButton(item.id)"
      >
        <mat-icon>{{ item.icon }}</mat-icon>
      </button>
    }
    @case ('menu') {
      @if (item.items.length) {
        <button mat-icon-button matTooltip="{{ item.tooltip }}" [matMenuTriggerFor]="menu">
          <mat-icon>{{ item.icon }}</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          @for (menuItem of item.items; track menuItem) {
            <button mat-menu-item (click)="onClickButton(menuItem.id)">
              <mat-icon>{{ menuItem.icon }}</mat-icon>
              <span>{{ menuItem.tooltip }}</span>
            </button>
          }
        </mat-menu>
      }
    }
  }
</ng-template>